<template>
  <v-container
    v-if="authenticationMixin.checkedLogin"
    class="content pa-0"
    fluid
  >
    <!-- Hero section -->
    <page-hero
      intro="Overzicht van de publicaties rond het overlijdensbericht."
      title="Publicaties"
    />

    <!-- Publicaties -->
    <v-row justify="center">
      <v-col
        class="center mb-8"
        cols="12"
        md="10"
        lg="8"
      >
        <div
          v-if="listMixin.list.length === 0"
          class="publicatie-empty text-center"
        >
          Er zijn momenteel geen publicaties om weer te geven.
        </div>

        <div
          v-else
          class="publicatie-card"
        >
          <!-- Header -->
          <div class="publicatie-row publicatie-row--header">
            <span class="publicatie-col publicatie-col--date">Datum</span>
            <span class="publicatie-col publicatie-col--type">Type</span>
            <span class="publicatie-col publicatie-col--paper">Krant</span>
            <span class="publicatie-col publicatie-col--action" />
          </div>

          <!-- Rows -->
          <div
            v-for="(publicatie, index) in listMixin.list"
            class="publicatie-row"
            :class="{ 'publicatie-row--alt': index % 2 === 1 }"
            :key="index"
          >
            <span class="publicatie-col publicatie-col--date">
              {{ FormatMixin_FormatDateTime(publicatie.datumPublicatie, formatMixin.date.database, formatMixin.date.date) }}
            </span>
            <span class="publicatie-col publicatie-col--type">
              {{ publicatie.typeCode.longDescription }}
            </span>
            <span class="publicatie-col publicatie-col--paper">
              {{ publicatie.krantCode.longDescription }}
            </span>
            <span class="publicatie-col publicatie-col--action">
              <v-btn
                color="primary"
                :disabled="!publicatie.idBestand"
                rounded
                size="small"
                @click="Download(publicatie)"
              >
                <v-icon
                  class="mr-1"
                  size="16"
                >
                  mdi-download
                </v-icon>
                Download
              </v-btn>
            </span>
          </div>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import authenticationMixin from '@/mixins/authenticationMixin'
import blobMixin from '@/mixins/blobMixin'
import commonMixin from '@/mixins/commonMixin'
import errorMixin from '@/mixins/errorMixin'
import listMixin from '@/mixins/listMixin'
import PageHero from '@/components/PageHero.vue'
import klantService from '@/services/klantService'
import rapportService from '@/services/rapportService'

export default {
  name: 'PublicatiesComponent',
  components: {
    PageHero
  },
  mixins: [
    authenticationMixin,
    blobMixin,
    commonMixin,
    errorMixin,
    listMixin
  ],
  mounted () {
    window.scrollTo({ top: 0, behavior: 'smooth' })
    this.AuthenticationMixin_CheckIfLoggedIn()
    this.$store.state.headers.keuzesUitvaart = true
    klantService.Init(this)
    rapportService.Init(this)
    this.GetUitvaartOverlijdensberichtPublicatieList()
  },
  beforeUnmount () {
    this.$store.state.headers.keuzesUitvaart = false
  },
  methods: {
    async Download (publicatie) {
      this.CommonMixin_Load(this.$options.name, true)
      const blob = {
        bestandsnaam: `${publicatie.typeCode.longDescription} ${publicatie.krantCode.longDescription}`,
        idBlob: publicatie.idBestand
      }

      await this.BlobMixin_DownloadExisting(blob)
      this.CommonMixin_Load(this.$options.name, false)
    },
    async GetUitvaartOverlijdensberichtPublicatieList () {
      this.CommonMixin_Load(this.$options.name, true)
      const resp = await klantService.GetUitvaartOverlijdensberichtPublicatieList()

      if (resp && (resp.data || resp.data !== '')) {
        this.listMixin.list = resp.data
      }

      this.CommonMixin_Load(this.$options.name, false)
    }
  }
}
</script>

<style scoped>
.publicatie-empty {
  font-size: 16px;
  color: #999;
  padding: 48px 0;
}

.publicatie-card {
  border: 1px solid #e8e4dc;
  border-radius: 10px;
  overflow: hidden;
  background-color: #fdfcfa;
}

.publicatie-row {
  display: flex;
  align-items: center;
  padding: 14px 20px;
  gap: 8px;
}

.publicatie-row--header {
  background-color: #424E58;
  color: white;
  font-weight: 600;
  font-size: 13px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.publicatie-row--alt {
  background-color: #FBF7EE;
}

.publicatie-col {
  display: flex;
  align-items: center;
  font-size: 15px;
}

.publicatie-col--date {
  flex: 1;
}

.publicatie-col--type {
  flex: 1.5;
}

.publicatie-col--paper {
  flex: 1.5;
}

.publicatie-col--action {
  flex-shrink: 0;
}

@media (max-width: 960px) {
  .publicatie-row {
    flex-wrap: wrap;
    padding: 12px 14px;
  }

  .publicatie-col--date,
  .publicatie-col--type,
  .publicatie-col--paper {
    flex: none;
    width: 100%;
  }

  .publicatie-col--action {
    width: 100%;
    margin-top: 8px;
  }
}
</style>
